import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=e20cd188&"
import script from "./Grid.vue?vue&type=script&lang=js&"
export * from "./Grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\MasterBranches\\Maintenance_06.04\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e20cd188')) {
      api.createRecord('e20cd188', component.options)
    } else {
      api.reload('e20cd188', component.options)
    }
    module.hot.accept("./Grid.vue?vue&type=template&id=e20cd188&", function () {
      api.rerender('e20cd188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Orcamento/Remanejar/Grid.vue"
export default component.exports